import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import { useFetchImages } from '../../../../hooks/useFetchImages';
import { getPixabayImages } from '../../../../utils/api-images/getPixabayImages';
import { useSearchQuery } from '../../../../hooks/useSearchQuery';
import getUrlImage from '../../../../utils/api-images/getUrlImage';
import LoadingSpinner from './Partials/LoadingSpinner';
import ImagesContainer from './Partials/ImagesContainer';
import Image from './Partials/Image';
import DescriptionSection from './Partials/DescriptionSection';

const Pixabay = ({ setAppImage, maxHeight = '1450px' }) => {
  const [query, handleInputQuery] = useSearchQuery();
  const [detail, setDetail] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [{ images, loading }, more] = useFetchImages(query, getPixabayImages);

  const handleSelect = (img) => {
    const imageUrl = img.largeImageURL;
    setSelectedImage(imageUrl);
    setDetail({
      name: img.user,
      authorPage: img.pageURL
    });
    getUrlImage(imageUrl, setAppImage);
  };

  useEffect(() => {
    return () => {
      setDetail('');
      setSelectedImage(null);
    };
  }, []);

  return (
    <>
      <main className="space-y-3">
        <TextField
          id="search"
          label="Search"
          value={query}
          onChange={handleInputQuery}
          className="w-full"
          autoComplete="off"
        />
        <ImagesContainer more={more}>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <div
              className="grid grid-cols-3 gap-3 overflow-y-auto"
              style={{ maxHeight }}>
              {images.map((img, index) => {
                const imageUrl = img.largeImageURL;
                return (
                  <Image
                    key={index}
                    alt={img.user}
                    src={imageUrl}
                    userPage={img.pageURL}
                    selectImage={() => handleSelect(img)}
                    isSelected={selectedImage === imageUrl}
                  />
                );
              })}
            </div>
          )}
        </ImagesContainer>
      </main>
      <DescriptionSection
        title={'Pixabay Gallery Description'}
        detail={detail}
      />
    </>
  );
};

export default Pixabay;
